import { on } from 'delegated-events';
import A11yDialog from 'a11y-dialog';
import abort from '../../../javascripts/utils/abort';
import fitImageInsideContainer from '../../../javascripts/utils/fitImageInsideContainer';

on('click', '[data-media-lightbox]', (event) => {
  const { currentTarget: $trigger } = event;
  const { mediaLightbox: templateId } = $trigger.dataset;

  event.preventDefault();

  if (!templateId) {
    return;
  }

  const $media = $trigger.closest<HTMLElement>('.media') ?? abort();
  const $template = document.querySelector<HTMLTemplateElement>(`#${templateId}`) ?? abort();
  const $fragment = $template.content.cloneNode(true) as DocumentFragment;
  const $lightbox = $fragment.querySelector<HTMLElement>('.media__lightbox') ?? abort();
  const $container = $lightbox.querySelector<HTMLElement>('.media__lightbox-container') ?? abort();
  const $image = $container.querySelector<HTMLElement>('.media__lightbox-image') ?? abort();

  const dialog = new A11yDialog($lightbox);
  const resizeOberserver = new ResizeObserver(() => {
    fitImageInsideContainer($image, $container);
  });

  $lightbox.addEventListener('show', () => {
    fitImageInsideContainer($image, $container);
    resizeOberserver.observe($lightbox);
  });

  $lightbox.addEventListener('hide', () => {
    resizeOberserver.disconnect();
  });

  $lightbox.addEventListener('destroy', () => {
    $lightbox.remove();
  });

  $lightbox.addEventListener('click', (clickEvent) => {
    const { target: $target } = clickEvent;

    if ($target instanceof Element && $target.closest('[data-media-lightbox-action="close"]')) {
      clickEvent.preventDefault();
      dialog.destroy();
    }
  });

  $media.appendChild($lightbox);
  dialog.show();
});
